import { AppRouteProps } from "@bsm/component";
import { StudentProxyContainer } from "./container/StudentProxyContainer";

export const StudentProxyRoutes: Array<AppRouteProps> = [
    {
        path: "proxy",
        element: <StudentProxyContainer />,
    },
];